import { Component } from '@angular/core';


export class SkyTileContentSectionComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-tile-content-section',
  styles: [`.sky-tile-content-section {
  padding: 15px;
}
`],
  template: `<div class="sky-tile-content-section">
  <ng-content></ng-content>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
